module.exports = __webpack_public_path__ + "static/media/ic_workflow_getstarted.0391907a.svg";